import React from 'react';
import { Link } from 'react-router-dom';
import { Shield, Users, UserCog, ScrollText } from 'lucide-react';

const AdminHome: React.FC = () => {
    const adminMenuItems = [
        {
            path: '/admin/accounts',
            label: 'Contas',
            description: 'Visualizar e gerenciar todas as contas de sistema',
            icon: Users,
            color: 'bg-green-500',
        },
        {
            path: '/admin/user',
            label: 'Usuários',
            description: 'Visualizar e gerenciar todos os usuários do sistema',
            icon: UserCog,
            color: 'bg-blue-500',
        },
        {
            path: '/admin/logs',
            label: 'Logs de auditoria',
            description: 'Consultar o histórico de ações realizadas no sistema',
            icon: ScrollText,
            color: 'bg-violet-500',
        },
    ];

    return (
        <div className="space-y-6">
            <div className="flex items-center gap-3">
                <div className="p-3 bg-primary-100 rounded-lg">
                    <Shield className="h-6 w-6 text-primary-600" />
                </div>
                <div>
                    <h1 className="text-2xl font-bold text-secondary-900">Painel Administrativo</h1>
                    <p className="text-secondary-600">Gerencie o sistema e as configurações</p>
                </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                {adminMenuItems.map((item) => {
                    const Icon = item.icon;
                    return (
                        <Link
                            key={item.path}
                            to={item.path}
                            className="bg-white p-6 rounded-lg border border-secondary-200 hover:border-primary-300 hover:shadow-md transition-all duration-200 group"
                        >
                            <div className="flex items-start gap-4">
                                <div className={`${item.color} p-3 rounded-lg group-hover:scale-110 transition-transform duration-200`}>
                                    <Icon className="h-6 w-6 text-white" />
                                </div>
                                <div className="flex-1">
                                    <h3 className="text-lg font-semibold text-secondary-900 mb-1 group-hover:text-primary-600 transition-colors">
                                        {item.label}
                                    </h3>
                                    <p className="text-sm text-secondary-600">
                                        {item.description}
                                    </p>
                                </div>
                            </div>
                        </Link>
                    );
                })}
            </div>
        </div>
    );
};

export default AdminHome;

